var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 5C17.9596 5 18.3327 5.3731 18.3327 5.83333V10.8333C18.3327 11.2936 17.9596 11.6667 17.4993 11.6667H13.3327V15.8333C13.3327 16.2936 12.9596 16.6667 12.4993 16.6667H2.49935C2.03911 16.6667 1.66602 16.2936 1.66602 15.8333V10.8333C1.66602 10.3731 2.03911 10 2.49935 10H6.66602V5.83333C6.66602 5.3731 7.03911 5 7.49935 5H17.4993ZM8.33268 15H11.666V11.6667H8.33268V15ZM3.33268 15H6.66602V11.6667H3.33268V15ZM13.3327 10H16.666V6.66667H13.3327V10ZM8.33268 10H11.666V6.66667H8.33268V10Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.182e23797f15569ee43c7156c6ada8a2.svg";
export { ForwardRef as ReactComponent };